var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCompanies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 17.3333H9.33333V20H5.33333V17.3333ZM12 20H16V17.3333H12V20ZM5.33333 25.3333H9.33333V22.6667H5.33333V25.3333ZM12 25.3333H16V22.6667H12V25.3333ZM5.33333 9.33333H9.33333V6.66667H5.33333V9.33333ZM12 9.33333H16V6.66667H12V9.33333ZM5.33333 14.6667H9.33333V12H5.33333V14.6667ZM12 14.6667H16V12H12V14.6667ZM32 10.6667V32H0V4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0L17.3333 0C18.3942 0 19.4116 0.421427 20.1618 1.17157C20.9119 1.92172 21.3333 2.93913 21.3333 4V6.66667H28C29.0609 6.66667 30.0783 7.08809 30.8284 7.83824C31.5786 8.58839 32 9.6058 32 10.6667ZM18.6667 4C18.6667 3.64638 18.5262 3.30724 18.2761 3.05719C18.0261 2.80714 17.687 2.66667 17.3333 2.66667H4C3.64638 2.66667 3.30724 2.80714 3.05719 3.05719C2.80714 3.30724 2.66667 3.64638 2.66667 4V29.3333H18.6667V4ZM29.3333 10.6667C29.3333 10.313 29.1929 9.97391 28.9428 9.72386C28.6928 9.47381 28.3536 9.33333 28 9.33333H21.3333V29.3333H29.3333V10.6667ZM24 20H26.6667V17.3333H24V20ZM24 25.3333H26.6667V22.6667H24V25.3333ZM24 14.6667H26.6667V12H24V14.6667Z",
    fill: "url(#paint0_linear_1_188)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_188",
    x1: 0,
    y1: 16,
    x2: 32,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompanies);
export default __webpack_public_path__ + "static/media/icon-companies.07d38a5d6b06a3b0fb86843bc0e43595.svg";
export { ForwardRef as ReactComponent };